/**
 * SICH PLP — Loro Piana product card interactions
 * ----------------------------------------------------------------------------
 * - Click en swatch: cambia la imagen primaria del card al tejido seleccionado.
 * - Hover en swatch: muestra el nombre del tejido en el label.
 * - Mouseleave del card: limpia el label.
 * - Todos los swatches están habilitados — al hacer click cambian la imagen.
 *   Para entrar al PDP, el usuario hace click en la imagen del producto.
 */
(function () {
  'use strict';

  if (window.__sichPlpInitialized) return;
  window.__sichPlpInitialized = true;

  function swapCardImage(card, newImageUrl) {
    var primaryImg = card.querySelector('.sich-card__image--primary');
    if (!primaryImg || !newImageUrl) return;
    primaryImg.setAttribute('src', newImageUrl);
    primaryImg.removeAttribute('srcset');
  }

  function setActiveSwatch(card, swatch) {
    var allSwatches = card.querySelectorAll('.sich-card__swatch');
    for (var i = 0; i < allSwatches.length; i++) {
      allSwatches[i].classList.remove('is-active');
    }
    swatch.classList.add('is-active');
  }

  function setSwatchLabel(card, text) {
    var label = card.querySelector('.sich-card__swatch-label');
    if (!label) return;
    label.textContent = text || '';
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.sich-card__swatch');
    if (!swatch) return;

    e.preventDefault();

    var card = swatch.closest('sich-product-card');
    if (!card) return;

    var newImage = swatch.getAttribute('data-variant-image');
    var optionValue = swatch.getAttribute('data-option-value');

    swapCardImage(card, newImage);
    setActiveSwatch(card, swatch);
    setSwatchLabel(card, optionValue);
  });

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.sich-card__swatch');
    if (!swatch) return;

    var card = swatch.closest('sich-product-card');
    if (!card) return;

    var value = swatch.getAttribute('data-option-value') || '';
    setSwatchLabel(card, value);
  });

  document.addEventListener('mouseleave', function (e) {
    var card = e.target;
    if (!card || !card.matches || !card.matches('sich-product-card')) return;
    setSwatchLabel(card, '');
  }, true);
})();
